import type React from 'react'

import css from './styles.module.scss'

const ROWS = [2, 2, 4]

export const ApiKeysSkeleton: React.FC = () => (
  <div className={css.list}>
    {ROWS.map((scopes, index) => (
      <div key={index} className={css.row}>
        <div className={css.row_top}>
          <div className={css.row_main}>
            <div data-skeleton-animation className={css.sk_name} />
            <div data-skeleton-animation className={css.sk_meta} />
          </div>
          <div data-skeleton-animation className={css.sk_revoke} />
        </div>

        <div className={css.scopes}>
          {Array.from({ length: scopes }).map((_, i) => (
            <div key={i} data-skeleton-animation className={css.sk_scope} />
          ))}
        </div>
      </div>
    ))}
  </div>
)
